/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-empty-function */
import { layout } from './cose-bilkent-layout-impl.js';
class CoseBilkentLayoutFallbackWorker {
    start() { }
    postMessage(data) {
        const { elements, spacingFactor } = data;
        const layoutData = layout(elements, spacingFactor);
        this.onmessage({ data: layoutData });
    }
    onmessage() { }
    close() { }
}
export const coseBilkentLayoutFallbackWorker = {
    port: new CoseBilkentLayoutFallbackWorker()
};
